export enum SpeechToTextStatusesEnum {
  Inactive = 'inactive',
  Initializing = 'initializing',
  Active = 'active'
}

export const languagesList = [
  'en-US'
]
export const knownNamesList = [
  'Leobit',
  'Oleksa',
  'Oleksa Stelmakh',
  'Imnoo',
  'Karpel',
  'VismoX',
  'JS',
  'JavaScript',
  '.NET',
  'React',
  'Angular',
  'Ruby',
  '.NET MaUI',
  'Blazor',
  'Leora',
  'Krakiw',
  'Poland',
  'Lviv',
  'Ukraine',
  'Austin',
  'Texas',
  'LLM',
  'T&M',
  'BOT',
  'R&D',
  'RnD',
  'SDO',
  'QMO',
  'PMO',
  'CTO',
  'SDR',
  'fintech',
  'SAAS'
]

export const replacementsDictionary = [
  ['low beat', 'Leobit'],
  ['plowbeat', 'Leobit'],
  ['low bid', 'Leobit'],
  ['leo beat', 'Leobit'],
  ['lowbeat', 'Leobit'],
  ['lilbad', 'Leobit'],
  ['low bid', 'Leobit'],
  ['leobitz', 'Leobit'],
  ['libid', 'Leobit'],
  ['love beat', 'Leobit'],
  ['laboured', 'Leobit'],
  ['loud beat', 'Leobit'],
  ['level beat', 'Leobit'],
  ['level bit', 'Leobit'],
  ['outlaw beat', 'Leobit'],
  ['lower beat', 'Leobit'],
  ['love a bit', 'Leobit'],
  ['levelbeat', 'Leobit'],
  ['cliobeat', 'Leobit'],
  ['levitz', 'Leobit'],
  ['levabit', 'Leobit'],
  ['little bit', 'Leobit'],
  ['levit', 'Leobit'],
  ['loudit', 'Leobit'],
  ['eeobit', 'Leobit'],
  ['loveit', 'Leobit'],
  ['lobid', 'Leobit'],
  ['lavita', 'Leobit'],
  ['lobet', 'Leobit'],
  ['lewitt', 'Leobit'],
  ['labit', 'Leobit'],
  ['lubitz', 'Leobit'],
  ['clay a bit', 'Leobit'],
  ['labette', 'Leobit'],
  ['SARS', 'SAAS'],
  ['SAS', 'SAAS'],
  ['a lamb', 'LLM'],
  ['high lord', 'high load'],
  ['hi lord', 'high load'],
  ['booty', 'BOT'],
  ['beauty', 'BOT'],
  ['lubit', 'Leobit'],
  ['lebit', 'Leobit'],
  ['lewd', 'Leobit'],
  ['lao bid', 'Leobit']
]

export const SSMLReservedSymbols = [
  ["&", '&amp;'],
  ["<", '&lt;'],
  [">", '&gt;']
]

export const speechStartDelayInMs = 0
